var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3.3v5.413a5 5 0 013.5 0V3.3a4 4 0 00-3.5 0zm4.5 0v5.413a5 5 0 013.5 0V3.3a4 4 0 00-3.5 0zM6 2.432a5 5 0 00-4.75.135A.5.5 0 001 3v6.5a.5.5 0 00.75.433 4 4 0 014 0 .5.5 0 00.5 0 4 4 0 014 0A.5.5 0 0011 9.5V3a.5.5 0 00-.25-.433A5 5 0 006 2.432z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--book-90069aeb641e5f456528b7b3ecea0d63.svg";
export { SvgIconUiBook as Component };